<template>
  <LoadingComponent v-if="loadingPage" />
  <div v-else class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body row">
            <ul class="list-group px-xl-4">
              <router-link
                :to="{
                  name: 'arrendamientos-detalle',
                  params: {
                    arrendamiento_id: arrendamiento.id,
                  },
                }"
                v-for="arrendamiento in arrendamientos"
                :key="arrendamiento.id"
              >
                <li
                  class="list-group-item d-flex justify-content-between mb-2 border-radius-lg border-0 mt-2"
                >
                  <div class="d-flex align-items-center">
                    <div
                      class="icon icon-shape icon-sm me-3 bg-gradient-primary shadow text-center"
                    >
                      <i class="ri-hand-coin-line text-white opacity-10"></i>
                    </div>
                    <div class="d-flex flex-column">
                      <h6
                        class="mb-1 text-dark opacity-8 text-xs text-uppercase"
                      >
                        {{ arrendamiento.nombre }}
                      </h6>
                      <!-- <span class="text-xs"
                      >250 in stock,
                      <span class="font-weight-bold">346+ sold</span></span
                    > -->
                    </div>
                  </div>
                  <div class="d-flex">
                    <button
                      class="btn btn-link btn-icon-only btn-rounded btn-sm text-dark icon-move-right my-auto"
                    >
                      <i class="ni ni-bold-right" aria-hidden="true"></i>
                    </button>
                  </div>
                </li>
              </router-link>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appApi from "@/services/api";
import LoadingComponent from "@/components/LoadingComponent.vue";
export default {
  data() {
    return {
      loadingPage: true,
      arrendamientos: [],
    };
  },
  components: {
    LoadingComponent,
  },
  methods: {
    async getTipoArrendamientos() {
      this.arrendamientos = [];
      try {
        const response = await appApi().get("arrendamientos");
        this.arrendamientos = response.data;
        this.loadingPage = false;
      } catch (e) {
        console.log(e);
      }
    },
  },
  created() {
    this.getTipoArrendamientos();
  },
};
</script>

<style></style>
